import axios from "@axios";

export default {
  namespaced: true,
  state: { courses: [] },
  getters: {
    getCourses(state) {
      return state.courses;
    },
  },
  mutations: {
    setCourses(state, param) {
      state.courses = param;
    },
  },
  actions: {
    fetchCourses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/lms/admin/course/getallcourses")
          .then((response) => {
            ctx.commit("setCourses", response.data.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    fetchDashboardData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post("/lms/admin/course/getLmsDashboardData", {
            dateFilterId: queryParams.dateFilterId,
            courseId: queryParams.courseguid,
            startDate: queryParams.startDate,
            endDate: queryParams.endDate,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
